import { useRef, useState, useEffect } from "react";
import Dashboard from '../../Assets/Images/Blogs/VN20250811_170122.mp4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faUserTie, faBuilding, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import bgImage from '../../Assets/Images/Blogs/white3.avif';
import brochurePDF from '../../Assets/Images/Products/Edusuite360 Company Brochure Revised (6).pdf';
import "../../Assets/CSS/Styles.scss";

import {
  faFileCode,
  faMobileAlt,
  faCloud,
  faChartPie,
  faSlidersH,
  faRobot
} from '@fortawesome/free-solid-svg-icons';
import smsLogo from '../../Assets/Images/Icons/sms.png';
import whatsAppLogo from '../../Assets/Images/Icons/Wp.png';
import gmailLogo from '../../Assets/Images/Icons/email1.jpg';
import nttDataLogo from '../../Assets/Images/Icons/NTTdata.png';
import tallyErp9Logo from '../../Assets/Images/Icons/Tally.png';
import Mobile from '../../Assets/Images/Icons/Mobile.png'
import Communication from '../../Assets/Images/Icons/Communication.png'
import API from '../../Assets/Images/Icons/wifi.png'
import heroBackground from '../../Assets/Images/Aboutus/Services-BG-01.svg';
const Products = () => {

  const refLeft = useRef(null);
  const refRight = useRef(null);
  const [inViewLeft, setInViewLeft] = useState(false);
  const [inViewRight, setInViewRight] = useState(false);

  // Left to Right
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInViewLeft(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (refLeft.current) observer.observe(refLeft.current);
    return () => observer.disconnect();
  }, []);

  // Right to Left
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInViewRight(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (refRight.current) observer.observe(refRight.current);
    return () => observer.disconnect();
  }, []);


  
  const videoRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false); // start assuming playing

  useEffect(() => {
    const video = videoRef.current;

    // On play event, set isPaused to false (hide play button)
    const handlePlay = () => setIsPaused(false);
    // On pause event, set isPaused to true (show play button)
    const handlePause = () => setIsPaused(true);

    video.addEventListener("play", handlePlay);
    video.addEventListener("pause", handlePause);

    // Cleanup listeners on unmount
    return () => {
      video.removeEventListener("play", handlePlay);
      video.removeEventListener("pause", handlePause);
    };
  }, []);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };
  // --- State for FAQ Accordion ---
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const faqs = [
    {
      question: "How does EduSuite360 ensure NEP compliance?",
      answer: "Our platform is built with NEP 2.0 guidelines at its core, featuring competency-based assessment tools, holistic progress cards, and flexible curriculum management. We provide free updates as new compliance requirements are introduced.",
    },
    {
      question: "Is the platform accessible on mobile devices?",
      answer: "Yes, EduSuite360 is fully responsive and offers dedicated mobile apps for students, parents, and staff. All features are optimized for mobile use with offline capabilities for critical functions.",
    },
    {
      question: "Is the system hosted on the cloud?",
      answer: "Yes, EduSuite360 is a cloud-native solution hosted on enterprise- grade infrastructure with 99.9% uptime guarantee. We also offer on- premise deployment options for institutions with specific security requirements.",
    },
  ];

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };


  return (
    <div className="font-sans antialiased text-gray-800 mt50 ">
      {/* Hero Section (EduSuite360) */}
      <section
        className="relative text-white py-20 px-6 min-h-[600px] md:min-h-[500px] flex flex-col items-center justify-center text-center overflow-hidden"
      >
        <div
          className="absolute inset-0 bg-cover bg-center animate-slowzoom"
          style={{ backgroundImage: `url(${heroBackground})` }}
        ></div>

        <div className="absolute inset-0 bg-black bg-opacity-70 z-10"></div>


        <div className="relative z-20 mb-10 mt-10 ">
          <div className="container mx-auto max-w-7xl flex flex-col lg:flex-row items-center justify-between gap-12">
            <div className="text-center lg:text-left lg:w-1/2">
              <h1 className="font-heading font-bold-500 text-white text-2xl md:text-4xl lg:text-5xl mb-6">
                <span className="font-heading font-bold-500 text-[#F59E0B]"> EduSuite<sup>360</sup></span>
              </h1>
              <h5 className="font-heading lg:text-2xl mb-6">The All-in-One Cloud ERP for Smart Institutions</h5>
              <p className="font-ui text-white text-md leading-6 mt-6 mb-8 p">
                A powerful, NEP-ready 360-degree ERP built to streamline operations for educational institutions, schools, colleges, and multi-campus trusts.
              </p>
              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4">
                <Link to="/freedemo" className="inline-block w-full sm:w-auto">
                  <button className="bg-[#F59E0B] hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 w-full">
                    Book Free Demo
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </button>
                </Link>
                <a
                  href={brochurePDF}
                  download="brochure.pdf"
                  className="border border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-[#2B355A] transition-colors flex items-center justify-center gap-2 w-full sm:w-auto"
                >
                  Download Brochure
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                  </svg>
                </a>
              </div>
            </div>
            <div className="lg:w-1/2 mt-10 lg:mt-0 relative flex justify-center items-center">
              {/* Placeholder for the hero dashboard image with stats */}
             <div
      className="relative w-full max-w-lg rounded-lg shadow-2xl overflow-hidden cursor-pointer"
      onClick={togglePlay}
    >
      <video
        ref={videoRef}
        src={Dashboard}
        className="w-full h-full rounded-lg"
        preload="metadata"
        autoPlay
        muted
        loop
      />
      {isPaused && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-orange-500 hover:bg-orange-600 text-white rounded-full p-4 transition">
          <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" /> {/* ▶ Play Icon */}
          </svg>
        </div>
      )}
    </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-600 rounded-full p-4 hidden"> {/* Hidden circle, replace with actual play button */}
                <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8.25 4.5v15l7.5-7.5-7.5-7.5z" clipRule="evenodd" /></svg>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Why Choose EduSuite360? Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold text-[#111827]">
              Why Choose EduSuite360?
            </h2>
            <p className="text-center text-[15px] mb-2 text-[#374151] font-ui">
              Built for modern educational institutions with cutting-edge technology and compliance standards.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">

            {[
              {
                title: 'NEP Compliant',
                desc: 'Fully aligned with latest National Education Policy for a future-ready curriculum.',
                icon: faFileCode,
              },
              {
                title: 'Web & Mobile Compatible',
                desc: 'Accessible from anywhere on any device for seamless operations.',
                icon: faMobileAlt,
              },
              {
                title: 'Cloud-Based & Secure',
                desc: 'Enterprise-grade security with 99.9% uptime guaranteed.',
                icon: faCloud,
              },
              {
                title: 'BI Dashboards & Reports',
                desc: 'Real-time analytics and intelligent insights for informed decision making.',
                icon: faChartPie,
              },
              {
                title: 'Customizable Modules',
                desc: 'Tailored solutions for your institution needs and workflows.',
                icon: faSlidersH,
              },
              {
                title: 'Future-Ready Architecture',
                desc: 'Future-proof with machine learning capabilities for adaptive learning.',
                icon: faRobot,
              }
            ].map(({ title, desc, icon }, i) => (
              <div
                key={i}
                className="relative bg-white border-2 border-amber-500 rounded-xl shadow-md p-6 pt-10 transition-all duration-300 hover:scale-105 hover:shadow-lg"
              >
                {/* Floating Icon */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                  <div className="w-16 h-16 bg-amber-100 border-2 border-white shadow-md rounded-full flex items-center justify-center">
                    <FontAwesomeIcon icon={icon} className="text-amber-500 text-xl" />
                  </div>
                </div>

                {/* Content */}
                <div className="mt-6 text-center">
                  <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2">{title}</h3>
                  <p className="text-[15px] text-[#374151] font-ui">{desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Complete Institutional Management & Why EduSuite360? (Detailed) */}
      <section
        className="relative py-16 bg-cover bg-center bg-no-repeat  overflow-hidden "
        style={{
          backgroundImage: `url(${bgImage})`,
          maskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
        }}
      >
        <div className="absolute inset-0 bg-white bg-opacity-50 z-0"></div>
        <div className="container relative z-10  mx-auto px-6 max-w-7xl grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Complete Institutional Management Box */}
          <div className="p-8 bg-gradient-to-br  from-[#111827] via-[#202E6E] to-[#253687] rounded-2xl shadow-2xl text-center text-white  ">
            <h3 className="text-2xl font-heading font-bold mb-6">Complete Institutional Management</h3>

            <div className="grid grid-cols-2 gap-6">
              {/* 1 */}
              <div className="p-4 bg-[#2B355A] rounded-xl flex flex-col items-center hover:shadow-lg transition-shadow duration-200 transition-all duration-300 hover:scale-105 hover:shadow-lg">
                <FontAwesomeIcon icon={faGraduationCap} className="text-orange-400 text-3xl mb-2" />
                <p className="font-semibold font-ui">Student Lifecycle</p>
                <p className="text-sm font-ui text-gray-300">From admission to graduation</p>
              </div>

              {/* 2 */}
              <div className="p-4 bg-[#2B355A] rounded-xl flex flex-col items-center hover:shadow-lg transition-shadow duration-200 transition-all duration-300 hover:scale-105 hover:shadow-lg">
                <FontAwesomeIcon icon={faUserTie} className="text-orange-400 text-3xl mb-2" />
                <p className="font-semibold">Faculty Lifecycle</p>
                <p className="text-sm text-gray-300">Complete HR management</p>
              </div>

              {/* 3 */}
              <div className="p-4 bg-[#2B355A] rounded-xl flex flex-col items-center hover:shadow-lg transition-shadow duration-200 transition-all duration-300 hover:scale-105 hover:shadow-lg">
                <FontAwesomeIcon icon={faBuilding} className="text-orange-400 text-3xl mb-2" />
                <p className="font-semibold">Administrative Control</p>
                <p className="text-sm text-gray-300">Streamlined operations</p>
              </div>

              {/* 4 */}
              <div className="p-4 bg-[#2B355A] rounded-xl flex flex-col items-center hover:shadow-lg transition-shadow duration-200 transition-all duration-300 hover:scale-105 hover:shadow-lg">
                <FontAwesomeIcon icon={faGlobe} className="text-orange-400 text-3xl mb-2" />
                <p className="font-semibold">Multi-campus Sync</p>
                <p className="text-sm text-gray-300">Unified management</p>
              </div>
            </div>

            <div className="mt-6 border-t border-orange-400 pt-2 text-sm text-gray-300">
              Fully Integrated System
            </div>
          </div>

          {/* Right: Why EduSuite360 */}
          <div
            ref={refRight}
            className={`transition-opacity duration-1000 ${inViewRight ? 'animate-slideInRightToLeft' : 'opacity-0'
              }`}
          >
            <h3 className="font-heading mb-4 text-[25px] font-bold text-[#111827]">
              Why EduSuite360?
            </h3>
            <p className="text-[15px] mb-2 text-[#374151] font-ui">
              EduSuite360 empowers institutions to digitize end-to-end operations...
            </p>
            <ul className="space-y-4 font-ui">
              <li className="flex items-start gap-3">
                <FontAwesomeIcon icon={faCheckCircle} className="text-orange-400 w-5 h-5 mt-1" />
                <p><span className="font-semibold font-ui">Seamless Integration:</span> Unified data flow.</p>
              </li>
              <li className="flex items-start gap-3">
                <FontAwesomeIcon icon={faCheckCircle} className="text-orange-400 w-5 h-5 mt-1" />
                <p>
                  <span className="font-semibold font-ui">Real-time Visibility:</span> Monitor every aspect of your institution
                  with live dashboards.
                </p>
              </li>
              <li className="flex items-start gap-3">
                <FontAwesomeIcon icon={faCheckCircle} className="text-orange-400 w-5 h-5 mt-1" />
                <p>
                  <span className="font-semibold font-ui">Compliance Ready:</span> Built-in NEP compliance and audit-ready
                  reports.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* ERP Module Grid - Core Functional Areas */}
      <section
        className="relative py-16 bg-cover bg-center bg-no-repeat overflow-hidden "
      >
        <div className="absolute inset-0 bg-white bg-opacity-30 z-0"></div>
        <div className="container relative z-10 mx-auto px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold text-[#111827]">
              ERP Module Grid - Core Functional Areas
            </h2>
            <p className="text-center text-[15px] mb-20 text-[#374151] font-ui">
              Choose the modules that fit your institution's needs. <br />
              Each can be purchased to work independently or as part of the complete EduSuite360 ecosystem.
            </p>
          </div>

          {/* cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-5 gap-10">
            {/* Card template - repeat for each card */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 .9 2 2 2zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                Admissions & Student Enrollment
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Complete student lifecycle management, from inquiry to alumni.
              </p>
            </div>

            {/* 2 - Timetable & Attendance */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                Timetable & Attendance
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Automated scheduling and real-time attendance tracking.
              </p>
            </div>

            {/* 3 - Examination & Evaluation */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-2 16H8v-2h4v2zm0-4H8v-2h4v2zm3-4H8V7h7v3z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                Examination & Evaluation
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Streamlined exam planning, grading, and result processing.
              </p>
            </div>

            {/* 4 - Fees & Payments */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12zm-2-5h-3c0-1.65-1.35-3-3-3s-3 1.35-3 3H6v-2h12v2zm-6-4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                Fees & Payments
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Secure and automated fee collection and payment integration.
              </p>
            </div>

            {/* 5 - Certificates & Documents */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2-9h4v2h-4z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                Certificates & Documents
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Digital generation and secure document management system.
              </p>
            </div>

            {/* 6 - Faculty HR & Payroll */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM12 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 4h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                Faculty HR & Payroll
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Centralized platform for teacher/staff records and payroll.
              </p>
            </div>

            {/* 7 - Multi-Campus Trust */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 3L1 9v12h22V9L12 3zm0 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                Multi-Campus Trust
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Centralized management for educational groups and trusts.
              </p>
            </div>

            {/* 8 - BI Reports & Smart Analytics */}
            <div className="relative bg-white p-6 pt-12 rounded-lg shadow-md border border-amber-500 hover:shadow-lg transition-all duration-300 hover:scale-105 group text-center min-h-[180px] flex flex-col">
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-amber-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 11V3H8v8H2v10h20V11h-6zm-6 8H4v-6h6v6zm0-8V5h4v6h-4zm6 8h-4v-6h4v6zm0-8V5h4v6h-4z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-[20px] font-ui font-bold text-[#111827] mb-2 mt-2 flex-grow flex items-center justify-center">
                BI Reports & Smart Analytics
              </h3>
              <p className="text-[15px] text-[#374151] font-ui opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-[100px] transition-all duration-300 overflow-hidden">
                Advanced analytics for data-driven decision making and insights.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Smart Dashboards & Analytics */}
      <section
        className="relative py-16 bg-cover bg-center bg-no-repeat  overflow-hidden "
        style={{
          backgroundImage: `url(${bgImage})`,
          maskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
        }}
      >
        <div className="absolute inset-0 bg-white bg-opacity-30 z-0"></div>
        <div className="container mx-auto  relative z-10 px-6 max-w-7xl grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div
            ref={refLeft}
            className={`transition-opacity duration-1000 ${inViewLeft ? 'animate-slideInLeft' : 'opacity-0'
              }`}
          >
            <h2 className="font-heading mb-4 text-[30px] font-bold text-[#111827]">
              Smart Dashboards & Analytics
            </h2>
            <p className="text-[18px] mb-6 text-[#374151] font-ui">
              Monitor academic health, attendance trends, fee collections, and faculty performance through real-time dashboards.
            </p>
            <ul className="space-y-3 text-gray-700 mb-8">
              <li className="flex items-center gap-3 text-[17px] font-ui">
                <svg className="w-5 h-5 text-[#faa913]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M3 17l6-6 4 4 8-8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Real-time performance analytics
              </li>
              <li className="flex items-center gap-3 text-[17px] font-ui">
                <svg className="w-5 h-5 text-[#faa913]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M17 20h5v-2a4 4 0 0 0-3-3.87M9 20H4v-2a4 4 0 0 1 3-3.87m6-5a4 4 0 1 0-8 0 4 4 0 0 0 8 0zM17 20h-2a4 4 0 0 1-4-4v-1a4 4 0 0 1 4-4h2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Student and faculty insights
              </li>
              <li className="flex items-center gap-3 text-[17px] font-ui">
                <svg className="w-5 h-5 text-[#faa913]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M12 8c-2.21 0-4 1.343-4 3s1.79 3 4 3 4 1.343 4 3-1.79 3-4 3m0-12V4m0 16v-2m-4-5h8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Financial health monitoring
              </li>
              <li className="flex items-center gap-3 text-[17px] font-ui">
                <svg className="w-5 h-5 text-[#faa913]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M12 6v6l4 2M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Attendance and engagement tracking
              </li>
            </ul>
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="bg-gradient-to-br from-[#111827] via-[#202E6E] to-[#253687] text-white p-6 rounded-xl shadow-xl w-full max-w-lg">
              <h3 className="text-lg font-semibold mb-4">Institution Dashboard</h3>
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div className="bg-[#1e2a78] p-4 rounded-lg">
                  <p className="text-sm text-gray-300">Total Students</p>
                  <h4 className="text-2xl font-bold">2,456</h4>
                  <p className="text-green-400 text-xs">↑ 5.2%</p>
                </div>
                <div className="bg-[#1e2a78] p-4 rounded-lg">
                  <p className="text-sm text-gray-300">Attendance Rate</p>
                  <h4 className="text-2xl font-bold">94.8%</h4>
                  <p className="text-green-400 text-xs">↑ 2.1%</p>
                </div>
                <div className="bg-[#1e2a78] p-4 rounded-lg">
                  <p className="text-sm text-gray-300">Fee Collection</p>
                  <h4 className="text-2xl font-bold">₹18.5L</h4>
                  <p className="text-green-400 text-xs">↑ 12.3%</p>
                </div>
                <div className="bg-[#1e2a78] p-4 rounded-lg">
                  <p className="text-sm text-gray-300">Faculty Rating</p>
                  <h4 className="text-2xl font-bold">4.7/5</h4>
                  <p className="text-green-400 text-xs">↑ 0.3</p>
                </div>
              </div>
              <div className="bg-[#1e2a78] p-4 rounded-lg">
                <p className="text-sm text-gray-300 mb-2">Weekly Attendance Trend</p>
                <div className="flex justify-between items-end space-x-1">
                  {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, idx) => (
                    <div key={day} className="flex flex-col items-center">
                      <div className="w-6 bg-[#faa913] rounded-t h-8 md:h-10"></div>
                      <span className="text-[10px] text-gray-300 mt-1">{day}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Integration & Platform Support */}
      <section className="relative py-16 py-16 bg_lblue overflow-hidden">
        {/* <div className="absolute inset-0 bg-white bg-opacity-50 z-0"></div> */}
        <div className="container relative z-10 mx-auto px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold text-[#111827]">
              Integration & Platform Support
            </h2>
            <p className="text-[15px] mb-6 color: #374151 font-ui">
              EduSuite360 seamlessly integrates with your existing systems and supports multiple platforms <br className="hidden sm:block" />
              for maximum flexibility and connectivity.
            </p>
          </div>

          {/* Hexagonal Grid Container */}
          <div className="flex flex-col items-center mb-12">
            {/* Hexagon container styles */}
            <style jsx>{`
    .hexagon-container {
      display: flex;
      justify-content: center;
      margin-bottom: -15px; /* Reduced for mobile */
    }
    .hexagon {
      width: 80px; /* Smaller for mobile */
      height: 92px; /* Adjusted proportionally */
      position: relative;
      margin: 0 10px; /* Reduced spacing for mobile */
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
      background: #f00;
      box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
      transition: all 0.3s ease;
    }
    /* Hexagon border using pseudo-element */
    .hexagon::before {
      content: "";
      position: absolute;
      top: -2px; /* Border width */
      left: -2px; /* Border width */
      right: -2px; /* Border width */
      bottom: -2px; /* Border width */
      background: #faa913;
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
      z-index: -1;
    }
    .hexagon-content {
      width: calc(100% - 4px); /* Account for border */
      height: calc(100% - 4px); /* Account for border */
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
      background: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .hexagon img {
      width: 40px; /* Smaller for mobile */
      height: 40px; /* Smaller for mobile */
      object-fit: contain;
      margin-bottom: 5px;
    }
    .hexagon span {
      font-size: 11px; /* Slightly smaller for mobile */
      color: #374151;
      font-weight: 500;
    }
    .offset {
      margin-left: 45px; /* Adjusted for mobile */
    }

    /* Medium screens and up */
    @media (min-width: 768px) {
      .hexagon-container {
        margin-bottom: -30px;
      }
      .hexagon {
        width: 100px;
        height: 115px;
        margin: 0 10px;
      }
      .hexagon img {
        width: 50px;
        height: 50px;
      }
      .hexagon span {
        font-size: 12px;
      }
      .offset {
        margin-left: 55px;
      }
      .offset2 {
        margin-left: 0px;
      }
    }
  `}</style>

            {/* First row with 3 hexagons */}

            <div className="hexagon-container ">
              {/* SMS */}
              <div className="hexagon">
                <div className="hexagon-content">
                  <img src={smsLogo} alt="SMS Logo" />
                  <span>SMS</span>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="hexagon">
                <div className="hexagon-content">
                  <img src={whatsAppLogo} alt="WhatsApp Logo" />
                  <span>WhatsApp</span>
                </div>
              </div>

              {/* Gmail */}
              <div className="hexagon">
                <div className="hexagon-content">
                  <img src={gmailLogo} alt="Gmail Logo" />
                  <span>Gmail</span>
                </div>
              </div>
            </div>


            {/* Second row with 2 hexagons (offset) */}

            <div className="hexagon-container offset2 mt-2 ">
              {/* NTT DATA */}
              <div className="hexagon">
                <div className="hexagon-content">
                  <img src={nttDataLogo} alt="NTT DATA Logo" />
                  <span>NTT DATA</span>
                </div>
              </div>

              {/* Tally ERP.9 */}
              <div className="hexagon">
                <div className="hexagon-content">
                  <img src={tallyErp9Logo} alt="Tally ERP.9 Logo" />
                  <span>Tally ERP.9</span>
                </div>
              </div>
            </div>

          </div>

          {/* Integration Features Grid */}
          <div className=" grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="mt-5 bg-blue-800/30 p-6 md:p-11 rounded-lg shadow-lg max-w-full md:max-w-[500px] mx-auto">
              <div className="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mx-auto mb-4">
                <img src={Mobile} alt="Mobile Logo" className="w-16 h-16 object-contain mb-2" />
              </div>
              <h3 className="text-xl font-bold text-[#111827] mb-2">Mobile Apps</h3>
              <p className="text-[15px] mb-6 color: #374151 font-ui">
                Android & iOS apps for students, faculty, and administration.
              </p>
            </div>
            <div className="mt-5 bg-blue-800/30 p-6 md:p-11 rounded-lg shadow-lg max-w-full md:max-w-[800px] mx-auto">
              <div className="flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mx-auto mb-4">
                <img src={API} alt="Mobile Logo" className="w-16 h-16 object-contain mb-2" />
              </div>
              <h3 className="text-xl font-bold text-[#111827] mb-2">API Integration</h3>
              <p className="text-[15px] mb-6 color: #374151 font-ui">
                RESTful APIs for seamless integration with existing systems.
              </p>
            </div>
            <div className="mt-5 bg-blue-800/30 p-6 md:p-11 rounded-lg shadow-lg max-w-full md:max-w-[800px] mx-auto">
              <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mx-auto mb-4">
                <img src={Communication} alt="Mobile Logo" className="w-16 h-16 object-contain mb-2" />
              </div>
              <h3 className="text-xl font-bold text-[#111827] mb-2">Communication</h3>
              <p className="text-[15px] mb-6 color: #374151 font-ui">
                Multi-channel communication with automated notifications.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Frequently Asked Questions */}
      <section className="py-16 bg-[#F8F9FA]">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold text-[#111827]">
              Frequently Asked Questions
            </h2>
            <p className="text-center text-[15px] mb-2 text-[#374151] font-ui">
              Get answers to common questions about EduSuite360.
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white p-4 rounded-lg shadow-xl border border-[#F59E0B] overflow-hidden cursor-pointer" onClick={() => toggleFaq(index)}>
                <div className="flex justify-between items-center">
                  <h3 className=" text-[18px] mb-2 mt-2 font-bold font-ui text-[827#111]">{faq.question}</h3>
                  <svg
                    className="w-5 h-5 text-[#FF6A00] flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
                {openFaqIndex === index && (
                  <p className="text-[15px] mt-6 color: #374151 font-ui">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reimagine how your institution works with EduSuite360 */}
      <section className="py-20 bg-[#2B355A] text-white text-center">
        <div className="container mx-auto px-6 max-w-4xl">
          <h2 className="font-heading font-bold mb-5 text-2xl md:text-[35px]">
            Reimagine how your institution works with
          </h2>
          <span className="mt-2 font-heading font-bold text-2xl md:text-[35px] text-[#F59E0B]">EduSuite<sup>360</sup></span>
          <p className="font-heading font-bold mb-4 mt-4 text-xl md:text-[25px]">
            India's next-gen Education ERP
          </p>
          <p className="text-sm md:text-[18px] font-ui mb-8">
            Join thousands of educational institutions that have transformed their operations with EduSuite360. Experience the power of integrated, intelligent, and scalable education management.
          </p>

          <div className="flex flex-col md:flex-row justify-around items-center gap-8 mb-12">
            <div className="mb-4 md:mb-0">
              <p className="text-4xl md:text-3xl font-bold text-[#FFA500]">10+</p>
              <p className="text-gray-300 text-sm">Year Of Experience</p>
            </div>
            <div className="mb-4 md:mb-0">
              <p className="text-4xl md:text-3xl font-bold text-[#FFA500]">24hrs</p>
              <p className="text-gray-300 text-sm">Service Support</p>
            </div>
            <div>
              <p className="text-4xl md:text-3xl font-bold text-[#FFA500]">99.9%</p>
              <p className="text-gray-300 text-sm">Uptime Guaranteed</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/freedemo" className="inline-block w-full sm:w-auto">
              <button className="bg-[#F59E0B] hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 w-full">
                Book Free Demo
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </Link>
            <a
              href={brochurePDF}
              download="brochure.pdf"
              className="border border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-[#2B355A] transition-colors flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              Download Brochure
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </a>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Products;